import React from "react";
import { NewTab, PageTab } from "../../../../components";
import ProcessingPage from "./Viewbatchlist/ProcessingPage";
import CreatedInvoives from "./Viewbatchlist/CreatedInvoives";
import Failed from "./Viewbatchlist/Failed";
import { useNavigate } from "react-router-dom";

const ViewBathList = ({ onBack }) => {
  const navigate = useNavigate();
  const ViewBatchTabs = [
    {
      title: "Processing",
      page: <ProcessingPage />,
      type: "main",
    },
    {
      title: "Created Invoices",
      page: <CreatedInvoives />,
      type: "main",
    },
    {
      title: "Failed",
      page: <Failed />,
      type: "main",
    },
    {
      title: "Back",
      type: "sub",
      icon: "arrow_left_alt",
      action: () => {
        onBack();
      },
    },
  ];
  return (
    <div>
      <NewTab
        tabs={ViewBatchTabs}
        color="black"
        variant="text"
        activeVariant="text"
      />
    </div>
  );
};

export default ViewBathList;
